export const PAGE_MODE = {
  ISACAVipOrg: 1,
  FDAVipOrg: 2,
  MDICVipOrg: 3,
  MddapOrg: 4,
  OrgUnit: 5,
  ISACAAppraiser: 6
};
